export const API_URL = 'http://localhost:9999/mock-api';
export const CONNECTOR_API_URL = 'http://localhost:9999/mock-api';
export const PARSE_APPLICATION_ID =
  'DwjY3wpxaUUR2Ehd4acfuRATcHuei7sPr4aHhUUjGB';
export const NETWORK_REQUEST_TIMEOUT_IN_MILLIS = 60000;
export const SHOW_VALIDATION_DROP_DOWN_MENUS = false;
export const VIDEA_BEACON_URL = 'ws://localhost:8090/Watcher';
export const MIXPANEL_TOKEN = 'test-token';
export const USERPILOT_TOKEN = 'test-token';
export const BUILD_CONFIGURATION = 'NON_FDA';
export const OKTA_DOMAIN = 'https://test.okta.com';
export const OKTA_CLIENT_ID = 'test-client-id';
export const SENTRY_ENABLED = false;
export const DEX_CONVERSION_API_URL = 'http://localhost:9999/mock-dex-api';
export const OPS_DASHBOARD_SHOW_WATCHLIST = false;
export const AIRTABLE_API_KEY = 'test-key';
export const AIRTABLE_BASE_ID = 'test-base-id';
export const PARENT_WINDOW_EMBED_URL = 'http://localhost:5174';
